import React from "react";
import { ArrowRight, PlayCircle } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_schlager-pro-daniel/artifacts/yp4462cl_IMG_9008.jpeg";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Daniel Lopes Portrait"
          className="w-full h-full object-cover object-[center_15%]"
          style={{
            imageRendering: "-webkit-optimize-contrast",
            filter: "contrast(1.06) saturate(1.08)",
          }}
          data-testid="hero-bg-image"
        />
        {/* Dark cinematic overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/55 to-[#0A0A0A]/10" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/80 via-transparent to-[#0A0A0A]/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 min-h-screen flex flex-col justify-end pb-24 md:pb-32 pt-32">
        <div className="max-w-3xl">
          <p
            className="overline reveal reveal-delay-1"
            data-testid="hero-overline"
          >
            <span className="gold-rule mr-4 align-middle" />
            Vom DSDS-Liebling zur modernen Schlager-Stimme
          </p>

          <h1
            className="reveal reveal-delay-2 font-display text-white hero-text-shadow mt-6 leading-[0.95] tracking-tight"
            style={{ fontSize: "clamp(3.2rem, 9vw, 8rem)", fontWeight: 600 }}
            data-testid="hero-headline"
          >
            Daniel
            <br />
            <span className="italic text-[#D4AF37]">Lopes</span>
          </h1>

          <p
            className="reveal reveal-delay-3 mt-8 max-w-xl font-body text-base md:text-lg text-[#D9D9D9] leading-relaxed hero-text-shadow"
            data-testid="hero-tagline"
          >
            Eine Bühnenpräsenz, die Festivals füllt — und Veranstalter
            zurückkommen lässt. Premium-Schlager auf höchstem Niveau,
            geboren aus 20 Jahren Live-Erfahrung.
          </p>

          <div
            className="reveal reveal-delay-4 mt-12 flex flex-wrap items-center gap-4"
            data-testid="hero-cta-group"
          >
            <a
              href="#booking"
              className="btn-primary"
              data-testid="hero-buchen-button"
            >
              Künstler buchen
              <ArrowRight size={16} strokeWidth={1.5} />
            </a>
            <a
              href="#live"
              className="inline-flex items-center gap-3 text-[#F5F5F5] hover:text-[#D4AF37] transition-colors duration-300 text-sm tracking-[0.18em] uppercase"
              data-testid="hero-showreel-link"
            >
              <PlayCircle size={28} strokeWidth={1} className="text-[#D4AF37]" />
              Live-Showreel ansehen
            </a>
          </div>
        </div>

        {/* Stats row */}
        <div
          className="reveal reveal-delay-5 mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-16 max-w-4xl border-t border-white/10 pt-10"
          data-testid="hero-stats"
        >
          {[
            { label: "DSDS Staffel 1", value: "Top 10" },
            { label: "Single 2003", value: "Top 10" },
            { label: "Album 2003", value: "Top 20" },
            { label: "Bühnenjahre", value: "20+" },
          ].map((s) => (
            <div key={s.label} data-testid={`hero-stat-${s.label.replace(/\s+/g, "-").toLowerCase()}`}>
              <div className="font-display text-3xl md:text-4xl text-[#D4AF37]">
                {s.value}
              </div>
              <div className="mt-2 text-xs tracking-[0.22em] uppercase text-[#A3A3A3]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3">
        <span className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">
          Scroll
        </span>
        <div className="w-px h-12 bg-gradient-to-b from-[#D4AF37] to-transparent" />
      </div>
    </section>
  );
}
